const baseUrl = process.env.REACT_APP_SERVER_URL;

export async function fetchSearchResults(keyword = "", section = "", page = 1) {
  try {
    const params = new URLSearchParams({
      keyword,
      section,
      page: page.toString(), // Convert number to string
    });

    const response = await fetch(`${baseUrl}/api/search?${params.toString()}`);
    const data = await response.json();

    if (data.error) {
      console.error("Error:", data.error);
      return null;
    }

    return data;
  } catch (error) {
    console.error("Network error:", error);
    return null;
  }
}
